/**
 * @generated SignedSource<<917ce3151fefdfde8e61d8b78261844f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutShipmentNotes_deliveryOptions$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAllowCustomQuote_deliveryOptions">;
  readonly " $fragmentType": "CheckoutShipmentNotes_deliveryOptions";
}>;
export type CheckoutShipmentNotes_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutShipmentNotes_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShipmentNotes_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutShipmentNotes_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAllowCustomQuote_deliveryOptions"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "bbf567898929788d5815b6324c0d28c6";

export default node;
